// extracted by mini-css-extract-plugin
module.exports = {"container":"LostPasswordForm_container__30ETN","button":"LostPasswordForm_button__EO3VN"};